/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
    FactorMethodToJSONTyped,
} from './FactorMethod';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
    ChallengeTypeToJSONTyped,
} from './ChallengeType';
import type { SAMLChallengeOptions } from './SAMLChallengeOptions';
import {
    SAMLChallengeOptionsFromJSON,
    SAMLChallengeOptionsFromJSONTyped,
    SAMLChallengeOptionsToJSON,
    SAMLChallengeOptionsToJSONTyped,
} from './SAMLChallengeOptions';

/**
 * 
 * @export
 * @interface SAMLChallenge
 */
export interface SAMLChallenge {
    /**
     * 
     * @type {string}
     * @memberof SAMLChallenge
     */
    id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof SAMLChallenge
     */
    type: ChallengeType;
    /**
     * 
     * @type {FactorMethod}
     * @memberof SAMLChallenge
     */
    authentication_method: FactorMethod;
    /**
     * 
     * @type {SAMLChallengeOptions}
     * @memberof SAMLChallenge
     */
    options: SAMLChallengeOptions;
}



/**
 * Check if a given object implements the SAMLChallenge interface.
 */
export function instanceOfSAMLChallenge(value: object): value is SAMLChallenge {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('authentication_method' in value) || value['authentication_method'] === undefined) return false;
    if (!('options' in value) || value['options'] === undefined) return false;
    return true;
}

export function SAMLChallengeFromJSON(json: any): SAMLChallenge {
    return SAMLChallengeFromJSONTyped(json, false);
}

export function SAMLChallengeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SAMLChallenge {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': ChallengeTypeFromJSON(json['type']),
        'authentication_method': FactorMethodFromJSON(json['authentication_method']),
        'options': SAMLChallengeOptionsFromJSON(json['options']),
    };
}

export function SAMLChallengeToJSON(json: any): SAMLChallenge {
    return SAMLChallengeToJSONTyped(json, false);
}

export function SAMLChallengeToJSONTyped(value?: SAMLChallenge | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': ChallengeTypeToJSON(value['type']),
        'authentication_method': FactorMethodToJSON(value['authentication_method']),
        'options': SAMLChallengeOptionsToJSON(value['options']),
    };
}

